import { palette } from '@awarego-ui/components';

export const awareGoTheme = {
    primary: palette.evergreen.aspargus,
    secondary: palette.vibrant.raspberry,
};
